export default __webpack_public_path__ + "static/fa-regular-400-be09513bd0a013642e838f6e10a4ef5e.ttf";